import { all } from 'redux-saga/effects';
import dashboardSaga from '../redux/Dashboard/saga';

export default function* RootSaga() {
  yield all([dashboardSaga(),
    // add more saga
  ]);
}
